var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83203 5.0026H8.16536V3.66927H6.83203V5.0026ZM7.4987 12.3359C4.5587 12.3359 2.16536 9.9426 2.16536 7.0026C2.16536 4.0626 4.5587 1.66927 7.4987 1.66927C10.4387 1.66927 12.832 4.0626 12.832 7.0026C12.832 9.9426 10.4387 12.3359 7.4987 12.3359ZM7.4987 0.335938C6.62322 0.335937 5.75631 0.508376 4.94747 0.843407C4.13864 1.17844 3.40371 1.6695 2.78465 2.28856C1.53441 3.5388 0.832031 5.23449 0.832031 7.0026C0.832031 8.77071 1.53441 10.4664 2.78465 11.7166C3.40371 12.3357 4.13864 12.8268 4.94747 13.1618C5.75631 13.4968 6.62322 13.6693 7.4987 13.6693C9.26681 13.6693 10.9625 12.9669 12.2127 11.7166C13.463 10.4664 14.1654 8.77071 14.1654 7.0026C14.1654 6.12712 13.9929 5.26022 13.6579 4.45138C13.3229 3.64254 12.8318 2.90762 12.2127 2.28856C11.5937 1.6695 10.8588 1.17844 10.0499 0.843407C9.24108 0.508376 8.37418 0.335938 7.4987 0.335938ZM6.83203 10.3359H8.16536V6.33594H6.83203V10.3359Z",
    fill: "#dc2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconRed);
export default __webpack_public_path__ + "static/media/info-icon-red.b5220a30.svg";
export { ForwardRef as ReactComponent };